import { render, staticRenderFns } from "./dialogAddagent.vue?vue&type=template&id=fe36c6e4&scoped=true"
import script from "./dialogAddagent.vue?vue&type=script&lang=js"
export * from "./dialogAddagent.vue?vue&type=script&lang=js"
import style0 from "./dialogAddagent.vue?vue&type=style&index=0&id=fe36c6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe36c6e4",
  null
  
)

export default component.exports